import { useTranslation } from '@egw/i18n'
import { ModalDrawer, useModalState } from '@egw/components'
import { type FC } from 'react'
import { ChevronRightIcon } from '@heroicons/react/16/solid'
import { sendEvent } from '@egw/events'
import { SetPin } from './set-pin'

interface SetPinAttributeProps {
  cardId?: string
  alias: string
  onSuccessCb?: () => void
}

export const SetPinAttribute: FC<SetPinAttributeProps> = ({ cardId, alias }) => {
  const { t } = useTranslation('features-account')
  const { isOpen, openModal, closeModal } = useModalState()

  if (!cardId) return null

  return (
    <>
      <div
        id="setPinAttribute"
        className="!text-base max-md:px-2 group py-4 border-b transition-all duration-200 cursor-pointer border-light flex justify-between"
        onClick={() => {
          sendEvent('user_changePIN_click', {
            eventSource: 'egWealth',
            category: 'card-pin',
            subCategory: 'intent',
          })
          openModal()
        }}
      >
        {t('debit_card.change_pin')}
        <ChevronRightIcon className="fill-iconmuted md:group-hover:fill-iconfull h-6 w-6 stroke-none" />
      </div>
      <ModalDrawer isOpen={isOpen} onClose={closeModal} title={t('debit_card.set_pin_title')}>
        <SetPin alias={alias} cardId={cardId} closeModal={closeModal} isOpen={isOpen} />
      </ModalDrawer>
    </>
  )
}
